import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';

const BLUE = '#1A7FFF';
const BLUE_HOVER = '#1568D9';
const BLUE_SOFT = '#EBF3FF';
const DARK = '#0F1117';

/**
 * Bloque de descarga del PDF. Va ARRIBA del contenido, apenas se desbloquea:
 * quien llega a un lead magnet quiere el archivo, no leer primero. El contenido
 * de la página queda como respaldo para el que prefiere leerlo online.
 */
const DescargaPDF = ({ url, titulo = 'Descarga la guía completa en PDF', bajada, sx }) => (
  <Paper
    elevation={0}
    sx={{
      display: 'flex', flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'flex-start', sm: 'center' }, justifyContent: 'space-between',
      gap: 2, p: { xs: 2.5, md: 3 }, mb: 4, borderRadius: 3,
      border: `1px solid ${BLUE}`, bgcolor: BLUE_SOFT,
      ...sx,
    }}
  >
    <Box>
      <Typography sx={{
        fontWeight: 800, color: BLUE_HOVER, fontFamily: 'Kanit, sans-serif',
        fontSize: { xs: 16, md: 18 }, mb: 0.5,
      }}>
        {titulo}
      </Typography>
      <Typography sx={{ color: DARK, fontFamily: 'Kanit, sans-serif', fontSize: 14.5 }}>
        {bajada || 'Descárgala y tenla a mano. Abajo la tienes completa para leerla acá mismo.'}
      </Typography>
    </Box>
    <Button
      variant="contained" disableElevation component="a" href={url} download
      sx={{
        flexShrink: 0, py: 1.3, px: 3.5, fontFamily: 'Kanit, sans-serif', fontWeight: 700,
        fontSize: 15, textTransform: 'none', bgcolor: BLUE, '&:hover': { bgcolor: BLUE_HOVER },
      }}
    >
      Descargar PDF
    </Button>
  </Paper>
);

export default DescargaPDF;
